import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRouteError } from "react-router-dom";
export default function NoPage(){

    const navigate = useNavigate();
    const routeErr = useRouteError();

    const [status, setStatus] = useState(404)
    const [statusText, setStatusText] = useState("The Page Could Not Be Found")
    useEffect(() => {
        if(routeErr.status){
            setStatus(routeErr.status)
            if(routeErr.statusText){
                setStatusText(routeErr.statusText)
            }
        }
    }, [])

    const goBack = () => {
        navigate(-1);
    }
    return (
        <div className="gradient-bg h-screen w-full flex flex-col justify-center items-center">
            <div className="grid md:grid-cols-2 gap-6 grid-cols-1 align-middle items-center">
                <div>
                    <img src="/error.svg" className="h-80 w-full" alt=""  />
                </div>
                <div className="text-center md:text-start">
                    <h1 className="text-8xl font-fira">{status}</h1>
                    <h4 className="font-taviraj text-xl mb-8">{statusText}</h4>
                    <button onClick={goBack} className="mt-4 bg-blue-800 transition ease-in-out delay-150 font-semibold text-white py-4 px-8 rounded-lg hover:bg-blue-900">
                       Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}